<template>
  <i class="icon" :class="clazz">
    <slot></slot>
  </i>
</template>

<script>
export default {
  name: 'e-icon',

  data() {
    return {
      active: false,
    }
  },

  props: {
    icon: String,
  },

  computed: {
    clazz() {
      return [this.icon]
    },
  },
}
</script>

<style scoped>
@import '../src/assets/font/iconfont.css';
@import '../src/assets/font/icomoon.css';
</style>
